import React, { useState, useEffect } from 'react';
import { Star, Quote } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Testimonials = () => {
  const [testimonialsStats, setTestimonialsStats] = useState({
    testsCompleted: 10000,
    averageRating: 4.9,
    recommendUs: 95,
    custom: false
  });

  useEffect(() => {
    const fetchTestimonialsStats = async () => {
      try {
        const response = await axios.get(`${API}/testimonials-stats`);
        setTestimonialsStats(response.data);
      } catch (error) {
        console.error('Failed to fetch testimonials stats:', error);
        // Keep default values if API fails
      }
    };

    fetchTestimonialsStats();
  }, []);

  const testimonials = [
    {
      id: 1,
      name: "Sarah M.",
      role: "Married 5 years",
      text: "LuvCup helped me understand my partner's love language in ways I never imagined. Our communication has improved dramatically!",
      rating: 5,
      avatar: "👩"
    },
    {
      id: 2,
      name: "James K.",
      role: "Recently Engaged",
      text: "The AI insights were incredibly accurate. It's like having a relationship therapist in your pocket. Highly recommend!",
      rating: 5,
      avatar: "👨"
    },
    {
      id: 3,
      name: "Emily R.",
      role: "Single, Dating",
      text: "Taking these tests helped me understand myself better before jumping into a new relationship. Game changer!",
      rating: 5,
      avatar: "👩‍🦰"
    }
  ];

  return (
    <div className="py-16 px-6 bg-gradient-to-r from-rose-50 to-pink-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-4">
            What People Are Saying
          </h2>
          <p className="text-gray-600 text-lg">
            Join thousands discovering their love language
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id} 
              className="glass-card p-6 hover:shadow-xl transition-shadow relative"
            >
              {/* Quote icon */}
              <div className="absolute top-4 right-4 opacity-20">
                <Quote className="w-8 h-8 text-rose-600" />
              </div>

              {/* Rating */}
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star 
                    key={i} 
                    className="w-4 h-4 text-yellow-400 fill-current" 
                  />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center">
                <div className="text-3xl mr-3">{testimonial.avatar}</div>
                <div>
                  <p className="font-semibold text-gray-800">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust indicators */}
        <div className="mt-12 flex flex-wrap justify-center items-center gap-8 text-gray-600">
          <div className="text-center">
            <p className="text-3xl font-bold gradient-text">{testimonialsStats.testsCompleted.toLocaleString()}+</p>
            <p className="text-sm">Tests Completed</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold gradient-text">{testimonialsStats.averageRating}/5</p>
            <p className="text-sm">Average Rating</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold gradient-text">{testimonialsStats.recommendUs}%</p>
            <p className="text-sm">Recommend Us</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
